module.exports = __webpack_public_path__ + "static/media/IMG_8878.ba433d95.jpg";